import React from "react";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";

import { Button } from "components";
import { merchantBatchHistoryTabService } from "services";

import styles from "./modal.module.scss";

type MerchantTransactionsBatchModalProps = {
	show: boolean;
	onHide: () => void;
	merchantId: string;
	list: { [key: string]: any };
};

const MerchantTransactionsBatchModal = ({
	show,
	onHide,
	merchantId,
	list,
}: MerchantTransactionsBatchModalProps) => {
	const downloadTransactionCvs = id => {
		merchantBatchHistoryTabService.getTransactionCvs(merchantId, id);
	};

	return (
		<Modal
			show={show}
			onHide={onHide}
			centered
			className={styles.wrappBatchHistoryModal}
		>
			<Modal.Header closeButton>
				<Modal.Title as="h2" className="text-center">
					Transaction #: {list.batchNumber}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className={styles.wrappFicoDetails}>
					<div className={styles.ficoLeft}>
						<p>Time:</p>
					</div>
					<div className={styles.ficoRigth}>
						<p>{list.transactionTime}</p>
					</div>
				</div>
				<div className={styles.wrappFicoDetails}>
					<div className={styles.ficoLeft}>
						<p>Date:</p>
					</div>
					<div className={styles.ficoRigth}>
						<p>
							<Moment format="DD MMMM YYYY">
								{list.transactionDate}
							</Moment>
						</p>
					</div>
				</div>
				<div className={styles.wrappFicoDetails}>
					<div className={styles.ficoLeft}>
						<p>Transaction Type:</p>
					</div>
					<div className={styles.ficoRigth}>
						<p>{list.cardType}</p>
					</div>
				</div>
				<div className={styles.wrappFicoDetails}>
					<div className={styles.ficoLeft}>
						<p>Amount:</p>
					</div>
					<div className={styles.ficoRigth}>
						<p>$ {list.transactionAmount}</p>
					</div>
				</div>
				<div className={styles.wrappFicoDetails}>
					<div className={styles.ficoLeft}>
						<p>Auth Code:</p>
					</div>
					<div className={styles.ficoRigth}>
						<p>{list.transactionCode}</p>
					</div>
				</div>
				<div className={styles.wrappFicoDetails}>
					<div className={styles.ficoLeft}>
						<p>Card Type:</p>
					</div>
					<div className={styles.ficoRigth}>
						<p>{list.cardType}</p>
					</div>
				</div>
				<div className={styles.wrappFicoDetails}>
					<div className={styles.ficoLeft}>
						<p>First 6:</p>
					</div>
					<div className={styles.ficoRigth}>
						<p>{list.firstSixOFCard}</p>
					</div>
				</div>
				<div className={styles.wrappFicoDetails}>
					<div className={styles.ficoLeft}>
						<p>Last 4:</p>
					</div>
					<div className={styles.ficoRigth}>
						<p>{list.lastFourOfCard}</p>
					</div>
				</div>
				<div className={styles.wrappTerminalBtn}>
					<Button
						value="Download CSV"
						onClick={() => downloadTransactionCvs(list.id)}
					/>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default MerchantTransactionsBatchModal;
